
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/face-shape-detector",
      function () {
        return require("private-next-pages/face-shape-detector/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/face-shape-detector"])
      });
    }
  